// extracted by mini-css-extract-plugin
export default {"hiddenPlaceholder":"Milestone-module__hiddenPlaceholder--b_yit"};